import { FC } from "react";
import { Styled } from "../../ui/layout";

export const Skeleton: FC<Styled> = ({ className }) => (
  <div
    role="status"
    aria-busy="true"
    className={`animate-pulse bg-stone-200 dark:bg-stone-700 ${
      className ?? "h-[194px] w-full rounded-md"
    }`}
  >
    <span className="sr-only">Loading</span>
  </div>
);
